import type { Id } from '@hq/utils';
import { toQuery, type HttpClient } from '../client';
import type {
  CfgDeviceListQuery,
  CfgDeviceRow,
  CfgDeviceSaveRequest,
  CfgDeviceSaveResult,
  CfgDeviceStatusKind
} from '../types/device';
import type { PageResult } from '../types/result';

const BASE = '/cfg/device';

/** 设备台账（RFID 读写器 / PDA / 打印机 / 智能柜）：查询开放，维护需 `sys:config:manage`。 */
export function createCfgDeviceApi(http: HttpClient) {
  return {
    list(query: CfgDeviceListQuery = {}): Promise<PageResult<CfgDeviceRow>> {
      return http.request<PageResult<CfgDeviceRow>>({ path: BASE, query: toQuery(query) });
    },

    /** 设备编码全局唯一；`id` 为空即新建。 */
    save(body: CfgDeviceSaveRequest): Promise<CfgDeviceSaveResult> {
      return http.request<CfgDeviceSaveResult>({ path: BASE, method: 'POST', body });
    },

    setStatus(id: Id, status: CfgDeviceStatusKind): Promise<CfgDeviceSaveResult> {
      return http.request<CfgDeviceSaveResult>({ path: `${BASE}/${id}/status`, method: 'POST', body: { status } });
    }
  };
}

export type CfgDeviceApi = ReturnType<typeof createCfgDeviceApi>;
